import { AfterViewInit, Component, OnInit, Input } from '@angular/core';
import { CaseFormsService } from 'src/app/modules/case-forms/case-forms.service';
import { SurgicalTreatmentModel } from '../surgicalTreatment.model';
import { StaticDataService } from 'src/app/services/static-data.service';
import { UserService } from 'src/app/services/user.service';
import { Globals } from 'src/app/globals';
import { SurgicalService } from 'src/app/services/form/surgical.service';
import { NotesService } from 'src/app/services/notes.service';
import { TdoNoteSaveModel, TdoNoteAssociatedObject } from 'src/app/main-interface/controls/tdo-notes/models/tdo-note-save-model';
import { NoteCategoryEnum } from 'src/app/models/enum/note-category.enum';
import { NoteTypeEnum } from 'src/app/models/enum/note-type.enum';
import { MatDialog } from '@angular/material/dialog';
import { TreatmentAnesthesiaDialogComponent } from 'src/app/modules/treatment/dialogs/treatment-anesthesia-dialog/treatment-anesthesia-dialog.component';
import { UiService } from 'src/app/services/ui.service';
import { OrganizerOpenInImagingModel } from 'src/app/main-interface/controls/tdo-organizer/models/organizer-open-in-imaging.model';
import { TreatmentEndoDataModel } from 'src/app/modules/treatment/models/treatment-endo-data.model';
import { DataPatientCaseWorkItemToothModel } from 'src/app/models/teeth/data-patient-case-work-item-tooth.model';

@Component({
  standalone: false,
  selector: 'app-surgical-treatment',
  templateUrl: './surgical-treatment.component.html',
  styleUrls: ['./surgical-treatment.component.scss']
})
export class SurgicalTreatmentComponent implements OnInit, AfterViewInit {
  @Input() caseWorkItemFormsId: string;
  toothName: string = '';

  currentTreatment: SurgicalTreatmentModel;
  treatmentModel: TreatmentEndoDataModel;
  isLoading: boolean = false;

  constructor(
    private readonly caseService: CaseFormsService,
    private readonly staticDataService: StaticDataService,
    private readonly userService: UserService,
    private readonly globals: Globals,
    private readonly surgicalService: SurgicalService,
    private readonly notesService: NotesService,
    private readonly dialog: MatDialog,
    private readonly uiService: UiService
  ) {}

  ngAfterViewInit(): void {}

  ngOnInit(): void {
    this.isLoading = true;
    if (this.globals.currentPatientId && this.caseWorkItemFormsId) {
      this.loadTreatment(this.globals.currentPatientId, this.caseWorkItemFormsId).finally(() => {
        this.isLoading = false;
      });
    } else {
      this.currentTreatment = new SurgicalTreatmentModel();
      this.isLoading = false;
    }
    
  }

  async loadTreatment(patientId: string, caseWorkItemFormsId: string) {
    this.currentTreatment = await this.surgicalService.getSurgicalTreatmentForm(patientId, caseWorkItemFormsId).toPromise();
  }

  onSurgeryDateDoubleClick(event: any) {
    if (!this.currentTreatment.SurgeryDate) {
      this.currentTreatment.SurgeryDate = new Date();
      this.saveSurgicalTreatment();
    }
  }

  onCompletedDateDoubleClick(event: any) {
    if (!this.currentTreatment.CompletedDate) {
      this.currentTreatment.CompletedDate = new Date();
      this.saveSurgicalTreatment();
    }
  }

  onBooleanChange(event: any, key: string) {
    if (this.currentTreatment && key) {
      this.currentTreatment[key] = event.checked;
      this.saveSurgicalTreatment();
    }
  }

  // "Thru + Thru" No box: the inverse of isThruThru. It used to only flip the model without saving,
  // so after Yes the database kept isThruThru = 1 (TX-6983).
  onThruThruNoChange(event: any) {
    this.onBooleanChange({ checked: !event.checked }, 'isThruThru');
  }

        onSurgeryDateFocus(event: FocusEvent) {
          if (!this.currentTreatment.SurgeryDate) {
            this.currentTreatment.SurgeryDate = new Date();
            this.saveSurgicalTreatment();
          }
        }

        onCompleteDateFocus(event: FocusEvent) {
          if (!this.currentTreatment.CompletedDate) {
            this.currentTreatment.CompletedDate = new Date();
            this.saveSurgicalTreatment();
          }
        }
  saveSurgicalTreatment() {
    this.surgicalService.saveSurgicalTreatment(this.currentTreatment).subscribe(res => {
      if (res) {
        this.currentTreatment = res;
      }
    });
  }

  onDropdownItemSelected(event: any, key: string) {
    if (this.currentTreatment && key) {
      this.currentTreatment[key] = event.ValidValueItemId;
      this.saveSurgicalTreatment();
    }
  }

  get SurgeryDateFormatted(): string {
    const date = this.currentTreatment?.SurgeryDate;
    if (!date) return '';
    const d = new Date(date);
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  }

  get completedDateFormatted(): string {
    const date = this.currentTreatment?.CompletedDate;
    if (!date) return '';
    const d = new Date(date);
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  }

  onSurgeryStructureRemovalTimeChange(event: any, key: string) {
    if (this.currentTreatment && key) {
      this.currentTreatment[key] = event.value;
      this.saveSurgicalTreatment();
    }
  }

  onSurgerySoftTissueCheckInChange(event: any, key: string) {
    if (this.currentTreatment && key) {
      this.currentTreatment[key] = event.value;
      this.saveSurgicalTreatment();
    }
  }

  generateSurgicalTreatmentNote(): string {
    // List of enum fields and their display names
    const enumFields = [
      'enumSurgeryPreOpPrognosisId',
      'enumSurgeryPostOpPrognosisId',
      'enumSurgeryIncisionTypeId',
      'enumSurgeryPerfMatrixId',
      'enumSurgeryRootFractureId',
      'enumSurgerySutureId',
      'enumSurgerySutureNumberId',
      'enumSurgeryBrandId',
      'enumSurgeryHemostasisId',
      'enumSurgeryRetroFillingMatrixId',
      'enumSurgeryStructureRemovalTimeId',
      'enumSurgerySoftTissueCheckInId'
    ];
    let note = 'Surgical Treatment Summary\n';
    for (const key in this.currentTreatment) {
      if (!this.currentTreatment.hasOwnProperty(key)) continue;
      const value = this.currentTreatment[key];
      if (
        value &&
        typeof value !== 'function' &&
        key !== 'PatientID' &&
        key !== 'CaseWorkItemFormsId' &&
        key !== 'CaseWorkItemToothId' &&
        key !== 'MTEToothID'
      ) {
        let displayValue = value;
        if (enumFields.includes(key)) {
          const enumItem = this.staticDataService.getValidValueItemByItemId(value);
          if (enumItem && enumItem.ItemDisplayValue) {
            displayValue = enumItem.ItemDisplayValue;
          }
        }
        note += `${key}: ${displayValue}\n`;
      }
    }
    return note;
  }

  onSaveAsNote() {
    const noteText = this.generateSurgicalTreatmentNote();
    const noteModel = new TdoNoteSaveModel();
    noteModel.text = noteText;
    noteModel.patientId = this.currentTreatment.PatientID || this.globals.currentPatientId;
    noteModel.categoryEnumIds = [NoteCategoryEnum.SurgicalTreatment];
    noteModel.typeEnumIds = [NoteTypeEnum.Case];
    const assoc = new TdoNoteAssociatedObject();
    assoc.objectId = this.currentTreatment.CaseWorkItemFormsId;
    assoc.parentObjectName = 'CaseWorkItemFormsId';
    noteModel.associatedObjects = [assoc];
    this.notesService.saveNote(noteModel).subscribe(res => {
      // Optionally refresh notes or show a message
    });
  }
  onAnesthesiaClick() {
    // Map only the matching fields from currentTreatment to TreatmentEndoDataModel
    const treatmentModel: TreatmentEndoDataModel = new TreatmentEndoDataModel();
    const mapFields = [
      'PatientID', 'CaseWorkItemFormsId', 'CompletedDate',
      'CaseWorkItemTeeth', 'CaseWorkItemFormTeeth', 'cfgTeeth',
      'CaseWorkItemToothId', 'MTEToothID', 'ToothName', 'ToothNumber', 'ToothType', 'ToothSurface', 'ToothSurfaceNumber', 'ToothSurfaceType',
      'enumEndoInterimReportFollowInId', 'enumEndoInterimReportExtTreatmentID', 'InterimReportDate',
      // Add more mappings as needed if you want to prefill more fields
    ];
    mapFields.forEach(field => {
      if (this.currentTreatment[field] !== undefined) {
        treatmentModel[field] = this.currentTreatment[field];
      }
    });
    // Ensure arrays are initialized
    if (!treatmentModel.CaseWorkItemTeeth) treatmentModel.CaseWorkItemTeeth = [];
    if (!treatmentModel.CaseWorkItemFormTeeth) treatmentModel.CaseWorkItemFormTeeth = [];
    if (!treatmentModel.cfgTeeth) treatmentModel.cfgTeeth = [];

    // Initialize CaseWorkItemTeeth with the corresponding values
    treatmentModel.CaseWorkItemTeeth = [
      Object.assign(new DataPatientCaseWorkItemToothModel(), {
        CaseWorkItemToothId: this.currentTreatment.CaseWorkItemToothId,
        CaseWorkItemId: this.globals.currentPatientCaseWorkItemID,
        ToothID: this.currentTreatment.ToothID,
        Notation: '',
        dataPatientCaseWorkItemFormTooth: [],
        isSelected: true
      })
    ];

    this.dialog.open(TreatmentAnesthesiaDialogComponent, {
      width: '1000px',
      height: '600px',
      panelClass: 'dialog',
      data: treatmentModel
    });
  }

  onXRayAquireClick() {
    const mod = new OrganizerOpenInImagingModel();
    // If you have a folderId context, set it here. Otherwise, just open imaging for the patient.
    // mod.folderId = ...
    localStorage.setItem('open-in-imaging', JSON.stringify(mod));
    this.uiService.openImagingWindow();
  }
} 